var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTskLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.465 28.695h-6.46V46.078h-5.446V28.695h-6.4V24.08h18.306v4.615Zm1.657 1.754c0-4.488 3.467-6.57 8.055-6.754V0H.719v70.281h34.458V46.57c-5.234-.304-8.617-2.86-8.732-7.414h5.476c.246 2.215 1.692 3.139 4.307 3.139 1.785 0 3.539-.647 3.539-2.308 0-1.753-1.785-2.123-4.8-2.862-3.815-.892-7.845-2.061-7.845-6.675Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9 46.078h-6.17l-6.798-10.353v10.353H47.49v-21.98h5.442v10.42l6.799-10.354h6.168l-7.487 10.958L65.9 46.078ZM36.542 0v23.697c4.433.199 7.787 2.36 7.992 6.752h-5.322c-.216-1.693-1.508-2.646-3.538-2.646-1.908 0-3.17.83-3.17 2.062 0 1.537 1.693 1.906 4.985 2.645 4.092.954 7.784 2.215 7.784 6.922 0 4.529-3.793 7.07-8.731 7.164v23.685H71V0H36.543Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTskLogo);
export default __webpack_public_path__ + "static/media/tsk_logo.a7b8dd1c8367e27a7bf6f79cb2bde032.svg";
export { ForwardRef as ReactComponent };